/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_In_Desktop_Requires_OnlineInputs */



/**
* | output |
* | --- |
* | "Opening this link requires an online build of the desktop app." |
*
* @param {Open_In_Desktop_Requires_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_in_desktop_requires_online = /** @type {((inputs?: Open_In_Desktop_Requires_OnlineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_In_Desktop_Requires_OnlineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'ouverture de ce lien nécessite une version en ligne de l'application de bureau.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Öffnen dieses Links ist eine Online-Version der Desktop-App erforderlich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per aprire questo link è necessaria una versione online dell'applicazione desktop.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для открытия этой ссылки требуется онлайн-версия настольного приложения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Para abrir este enlace, es necesario tener instalada la versión en línea de la aplicación de escritorio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开此链接需要在线安装桌面应用程序。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このリンクを開くには、デスクトップアプリのオンライン版が必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस लिंक को खोलने के लिए डेस्कटॉप ऐप का ऑनलाइन संस्करण आवश्यक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abrir este link requer uma versão online do aplicativo para desktop.")
	return /** @type {LocalizedString} */ ("Opening this link requires an online build of the desktop app.")
});